import BreadScrumbs from "../../components/breadscrumb";
import ListCheckBox from "../../components/checkbox";
import { useState } from "react";
import NFTGallery from "../../components/nft-gallery";
import NFT from "../../components/nft";
import Merge from "../../components/merge";
import Box from "../../components/box";
function MarketPlacePage() {
    const [menu, setMenu] = useState(1)

    return (
        <>
            <BreadScrumbs name={'INVENTORY'} />
            <div className="w-full relative  px-[6.4rem] py-[7.8rem] xl:px-[25.5rem] flex flex-col sm:flex-row sm:justify-between sm:items-start  gap-[6.4rem] flex-nowrap">
                <div className="sm:max-w-[28rem] w-full grid sm:grid-cols-1 grid-cols-3 gap-[4rem] :">
                    <button onClick={() => setMenu(1)} type="button" className={`text-[2rem] font-bakbak font-normal py-[1.6rem] ${menu == 1 ? 'bg-primary text-black':'bg-third  text-white '}`}>NFT</button>
                    <button onClick={() => setMenu(2)} type="button" className={`text-[2rem] font-bakbak font-normal py-[1.6rem] ${menu == 2 ? 'bg-primary text-black':'bg-third  text-white '}`}>Merge</button>
                    <button onClick={() => setMenu(3)} type="button" className={`text-[2rem] font-bakbak font-normal py-[1.6rem] ${menu == 3 ? 'bg-primary text-black':'bg-third  text-white '}`}>BOX</button>
                </div>
               <div className="w-full">
               {menu == 1? <NFT /> : menu == 2 ? <Merge/> : menu==3 ? <Box/> :''}
               </div>
            </div>

        </>
    )
}

export default MarketPlacePage;